<template>
  <div class="pinyin-container">
    <el-card class="box-card">
      <el-form label-width="100px">
        <el-form-item label="输入内容">
          <el-input v-model="text" type="textarea" :rows="3" placeholder="请输入内容" class="input-area"></el-input>
        </el-form-item>
        <el-form-item label="分隔符">
          <el-input v-model="separator" placeholder="请输入分隔符"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isFirst" true-label="1" false-label="0">是否首字母</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="pinyin">转换拼音</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div class="result-area">{{str}}</div>
    </el-card>
  </div>
</template>

<script>
import {pinyin} from '../api/pinyin'
export default {
  name: 'pinyin',
  data () {
    return {
      text: '',
      str: '',
      isFirst: '',
      separator: ''
    }
  },
  methods: {
    pinyin () {
      const data = '{"text":"' + this.text + '","isFirst":"' + this.isFirst + '","separator":"' + this.separator + '"}'
      pinyin(data).then(response => {
        this.str = response.data
      })
    }
  }
}
</script>

<style scoped>
.pinyin-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.box-card {
  max-width: 100%;
}
.input-area {
  width: 100%;
}
.result-area {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  min-height: 60px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/view/pinyin.vue